import {SchemaProps} from "./JsonLdSchemaRouter";
import {
    articleSection,
    context,
    creationDate,
    description,
    keywords,
    modificationDate,
    newsAuthor,
    pictureUri,
    publisher,
    title,
    type_news
} from "./JsonLdUtil";

export function getNewsSchema(props: SchemaProps) {
    const publishedDate = creationDate(props);
    const modifiedDate = modificationDate(props);
    const keywordArray = keywords(props)
    const newsKeywords = keywordArray.length > 0 ? {"keywords": keywordArray} : undefined;

    const result: any = {
        "@context": context,
        "@type": type_news,
        "headline": title(props),
        "description": description(props),
        ...newsAuthor,
        "image": pictureUri(props),
        publisher,
        "articleSection": articleSection(props),
        ...newsKeywords
    };

    if (publishedDate) {
        result.datePublished = publishedDate;
    }
    if (modifiedDate) {
        result.dateModified = modifiedDate;
    }

    return result;
}
